export enum RUNTIME_MODES{
  STABLE = "stable",
  DEVELOPMENT = "development",
}

export enum HubTabs {
  // ALL = "ALL",
  YOUR_GAMES = "YOUR GAMES",
  MIX_GAMES = "MIX GAMES",
}

export enum SocialLoginType {
  APPLE,
  GOOGLE,
  DISCORD,
  TWITCH,
}

export enum ETournamentFilter {
  Tournaments = "Tournaments",
  Challenges = "Challenges",
  SitAndGo = "SitAndGo",
  CommunityTournaments = "CommunityTournaments",
}

export enum EPeopleFilter {
  Teams = "Teams",
  Leaderboard = "Leaderboard",
  Friends = "Friends",
  Community = "Community",
}

export enum EChatFilter {
  All = "All",
  Teams = "Teams",
  Tournaments = "Tournaments",
  Community = "Community",
  Matches = "Matches",
}

export enum EMyTournamentFilter {
  Upcoming = "Upcoming",
  // Live = "Live", // TOOD: add this later, either filter on client or server
  Past = "Past",
}

export enum TOURNAMENT_STATUS {
  OPENED = "OPENED",
  REGISTRATION_OPENED = "REGISTRATION_OPENED",
  CHECKIN = "CHECKIN",
  REGISTRATION_CLOSED = "REGISTRATION_CLOSED",
  PENDING = "PENDING",
  STARTED = "STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  FINISHED = "FINISHED",
  CLOSED = "CLOSED",
}

export enum EParticipantStatus {
  Active = "active",
  Registered = "registered",
  Defeated = "defeated",
  Winner = "winner",
}

export enum EMatchStatus {
  OPENED = "OPENED",
  WAITING = "WAITING",
  CHECKIN = "CHECKIN",
  STARTED = "STARTED",
  COLLECTING = "COLLECTING",
  FINISHED = "FINISHED",
  CONFLICT = "CONFLICT",
  PENDING = "PENDING",
}

export enum TeamRole {
  "CPT" = "captain",
  "CO-CPT" = "co-captain",
  "PLAYER" = "player",
  "SUB" = "substitute",
}
